import type { DropdownMenuItemProps, ItemProps } from '../../../../core'
import { DropdownMenuItem, Item } from '../../../../core'

export interface ProposeChangeDropdownMenuItemProps extends Omit<
  DropdownMenuItemProps,
  'children' | 'disabled' | 'icon'
> {
  onProposeChange: () => void
}

export function ProposeChangeDropdownMenuItem({
  onProposeChange,
  ...props
}: ProposeChangeDropdownMenuItemProps) {
  return (
    <DropdownMenuItem
      shouldCloseOnSelect={false}
      {...props}
      onSelect={(event) => {
        event.preventDefault()
        props.onSelect?.(event)
        onProposeChange()
      }}
    >
      {`Propose a change…`}
    </DropdownMenuItem>
  )
}

export interface ProposeChangeItemProps extends Omit<ItemProps, 'asChild'> {
  onProposeChange: () => void
}

export function ProposeChangeItem({
  onProposeChange,
  ...props
}: ProposeChangeItemProps) {
  return (
    <Item
      isInteractive
      {...props}
      onClick={(event) => {
        props.onClick?.(event)
        if (event.defaultPrevented === false) {
          onProposeChange()
        }
      }}
    >
      {`Propose a change`}
    </Item>
  )
}
